import React, { useEffect } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import { callServerTepngUserLogin, fireAxiosErrorMySwal, showBackDrop } from '../helpers/utils';
import { RoutePathNames } from '../helpers/constants';
import { useAppSelector } from '../store/store';

const { useNavigate } = require("react-router-dom");
const MySwal = withReactContent(Swal);

function Login() {

  const navigate = useNavigate()
  const appConfig = useAppSelector(state => state.appConfig.value);
  let queryParams = new URLSearchParams(window.location.search);
  const azureAuthRedirect = queryParams.get("azureauthredirect") === '1'
  // microsoft login redirect - the frond end url with the /login-tepnguser needs to be added to Azure App Service authentication Allowed external redirect URLs to allow for login redirect
 

  useEffect(() => {
    const login = () => {
        MySwal.fire(showBackDrop("User Sign in ongoing"));
        
        callServerTepngUserLogin()
          .then(response => {
            MySwal.close();
            const loginRedirectedFromUrl = localStorage.getItem('loginRedirectedFromUrl') || "/" + RoutePathNames.USERS;
            localStorage.removeItem('loginRedirectedFromUrl');
            navigate(loginRedirectedFromUrl);
          })
          .catch(function (error) {
            if (!azureAuthRedirect && error?.response?.status === 401) {
              let redirectUrl = new URL(window.location.origin + '/' + RoutePathNames.LOGIN);
              redirectUrl.searchParams.append('azureauthredirect', '1');
              const encodedRedirectUri = encodeURIComponent(redirectUrl.href);

              // Redirect to Azure AD login with specified post-login redirect URI
              window.location.replace(`${appConfig.SERVER_URL}/.auth/login/aad?post_login_redirect_uri=${encodedRedirectUri}`);
            } else {
              fireAxiosErrorMySwal(error);
            }
          });
    };

    login();
}, [appConfig.SERVER_URL, azureAuthRedirect, navigate]);

  return (<div></div>)
}

export default Login;